import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchProviders } from "../../../actions/callrecorder/providersActions";
import { setNewParams } from "../../../store/callrecorder/providersSlice";

import PageLayout from '../_partials/PageLayout';
import Edit from "./Edit";
import New from "./New";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import NavBarThree from "../../../componets/NavBarThree";
import Can from "../../../componets/Can";
import { PlusOutlined } from "@ant-design/icons";
import './style.scss';

const LIMIT = 42;

const Providers = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'search_by', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchProviders(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { is_active: true };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-providers'>
      <PageHeader title='Providers' />

      <Can capability='write_callrecorder'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Create Provider
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter dateRange />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Providers;
